import { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

// What the Profile page needs from the server that the app does not already hold:
// the email, whether the student joined through a school, and how many chats they have.
export default function useProfileFacts() {
  const [facts, setFacts] = useState({ email: "", inSchool: false, chatCount: null });

  useEffect(() => {
    let live = true;
    const get = async (path) => {
      try {
        const res = await fetch(`${API_BASE}${path}`, { credentials: "include" });
        return res.ok ? await res.json() : null;
      } catch (_) {
        return null;
      }
    };
    (async () => {
      const [me, chats] = await Promise.all([get("/auth/me"), get("/conversations")]);
      if (!live) return;
      setFacts({
        email: (me && me.user && me.user.email) || "",
        inSchool: !!(me && me.user && me.user.in_school),
        chatCount: chats && Array.isArray(chats.conversations) ? chats.conversations.length : null,
      });
    })();
    return () => {
      live = false;
    };
  }, []);

  return facts;
}
